<template>
  <div class="content-container">
    <search-comp @onSearch="attachData" @onReset="onReset">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Khách sạn</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.hotelIdList"
                    multiple
                    collapse-tags
                  >
                    <el-option
                      v-for="(hotel, index) in hotelList"
                      :key="index"
                      :value="hotel.id"
                      :label="hotel.name"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Ngày</div>
                <div class="child-w-80">
                  <!-- :date-data="agentItem.representative_card_date" -->
                  <!-- v-model="agentItem.representative_card_date" -->
                  <!-- @changeCalendar="onChangeDate2" -->
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>
    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container justify-space-between">
            <div class="das-form-title">
              <span class="main-title">Báo cáo ăn sáng</span>
            </div>
            <div class="button-containers-title">
              <InfoBtn @click="dialogFormVisible = true" />
              <el-dropdown trigger="click" @command="handleCommand">
                <button class="btn medium primary outline download-button">
                  <i class="el-icon-download"></i>
                </button>
                <el-dropdown-menu>
                  <el-dropdown-item command="pdf">Xuất PDF</el-dropdown-item>
                  <el-dropdown-item command="excel"
                    >Xuất Excel</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <button class="btn primary small">Xuất Excel</button> -->
            </div>
            <!-- <button class="btn medium primary outline">Thêm</button> -->
          </div>
          <hr />
          <div v-loading="loading" class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              class="agGrid"
              :header-height-setter="headerHeightSetter"
              dom-layout="scroll"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :auto-select-first-row="false"
              :auto-size-cell="true"
              row-selection="false"
            />
          </div>
        </div>
      </div>
    </div>

    <el-dialog
      title="Chú thích"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="500px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>
              Recode: Là mã đặt phòng nếu là khách lẻ, là mã đoàn nếu là khách
              đoàn
            </li>
            <li>Số phòng: tên hạng phòng và số phòng</li>
            <li>Ngày đến: Ngày khách Check in. format mặc định: DDMMYYYY</li>
            <li>Tên khách: Tên khách trong đặt phòng</li>
            <li>
              Ngày đi: Ngày đi dự kiến của khách theo đặt phòng. format mặc
              định: DDMMYYYY
            </li>
            <li>Người lớn: Số lượng người lớn của đặt phòng</li>
            <li>Trẻ em: số lượng trẻ em của đặt phòng</li>
            <li>Trạng thái: hiển thị dưới dạng checkbox.</li>
          </ul>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button class="btn primary small" @click="dialogFormVisible = false">
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { getAllHotel } from '@/api/hotel'
import {
  getBreakfastReportList,
  getBreakfastReportExcel
} from '@/api/report_service/breakfastReport'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import InfoBtn from './components/InfoBtn.vue'

export default {
  components: {
    CalendarRange,
    SelectWithSearchTable,
    InfoBtn
  },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        wrapText: true,
        autoHeight: true,
        suppressMovable: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      dialogFormVisible: false,
      hotelList: [],
      loading: false,
      searchParams: {
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(2, 'days').format('YYYY-MM-DD')
      },
      defaultSsearchParams: {
        hotelIdList: [],
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().add(2, 'days').format('YYYY-MM-DD')
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(2, 'days').format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().add(2, 'days').format('YYYY-MM-DD')
      },

      columns: [
        {
          headerName: this.$t('grid.column.bookingCode'),
          field: 'recode',
          tooltipField: 'recode',

          // cellClass: "grid-cell-centered",
          sortable: false,
          minWidth: 150
        },
        {
          headerName: this.$t('grid.column.roomNum'),
          field: 'room_num',
          tooltipField: 'room_num',

          // cellClass: "grid-cell-centered",
          // width: 100,
          sortable: false,
          minWidth: 120
        },
        {
          headerName: this.$t('grid.column.customerName'),
          field: 'guest_name',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          tooltipField: 'guest_name',
          minWidth: 100

          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.arrivalDate'),
          field: 'arrive_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 120

          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.departureDate'),
          field: 'depart_date',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 120,
          maxWidth: 150
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.expectAdult'),
          field: 'expert_adult_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.expectChild'),
          field: 'expert_child_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.realAdult'),
          field: 'real_adult_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },

        {
          headerName: this.$t('grid.column.realChild'),
          field: 'real_child_num',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100,
          maxWidth: 120
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.status'),
          field: 'status',
          tooltipField: 'status',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 100
          // cellClass: "grid-cell-centered",
        },
        {
          headerName: this.$t('grid.column.note'),
          field: 'desc',
          tooltipField: 'desc',
          // cellRenderer: 'CellRenderTextInput',
          sortable: false,
          minWidth: 150
          // cellClass: "grid-cell-centered",
        }
      ],
      rows: []
    }
  },
  created() {
    this.getListHotel()
  },
  mounted() {
    this.attachData()
  },
  methods: {
    handleCommand(cmmd) {
      if (cmmd == 'excel') {
        getBreakfastReportExcel(this.searchParams).then(res => {
          if (res) {
            const date = this.$moment().format('DD-MM-YYYY')
            console.log(res)
            const href = URL.createObjectURL(res)
            // create "a" HTML element with href to file & click
            const link = document.createElement('a')
            link.href = href
            link.setAttribute(
              'download',
              'breakfast_report_' + date + '.xlsx'
              // res.headers['content-disposition'].split('filename=')[1],
            ) // or any other extension
            document.body.appendChild(link)
            link.click()
            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link)
            URL.revokeObjectURL(href)
          } else {
            throw new Error(res)
          }
        })
      }
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },
    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },
    headerHeightSetter() {
      var padding = 30
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    },

    async getListHotel() {
      const data = await getAllHotel()
      this.hotelList = data.data
    },
    async attachData() {
      try {
        this.loading = true

        const data = await getBreakfastReportList(this.searchParams)
        // this.loading = false
        this.rows = []
        data?.data.forEach(element => {
          this.rows = [
            ...this.rows,
            {
              name: ['Ngày: ', element.date].join(' '),
              isFullWidthRow: true
            },
            ...element?.breakfastReportList
          ]
        })
        // this.rows = data.data
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    onReset() {
      this.searchParams = { ...this.defaultSearchParams }
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.attachData()
    }
  }
}
</script>

<style lang="scss">
.button-containers-title {
  display: flex;
  /* margin-top: 20px; */
  justify-content: flex-end;
  align-items: flex-end;
  gap: 10px;
  .download-button {
    padding: 10px 10px;
  }
}
</style>
